import * as React from 'react'
import AdjustButton from './AdjustButton'

export type RecordPackagingProps = {
  packaging: any
  onAdjust?: (packaging: any) => void
  className?: string
}

const RecordPackaging: React.FC<RecordPackagingProps> = ({ packaging, onAdjust, className }) => {
  const unit = packaging.item.default_consumption || packaging.item.base_unit_of_measure || ''
  const details = [packaging.item.title, `${packaging.amount} ${unit}`.trim()].filter(Boolean).join(', ')

  return (
    <div className={`card ${className || ''}`}>
      <div className="card-body p-2 d-flex justify-content-between align-items-center">
        <span>{details}</span>
        {onAdjust && <AdjustButton onClick={() => onAdjust(packaging)} />}
      </div>
    </div>
  )
}

export default RecordPackaging 